<div class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th translate *ngIf="includeAvailability">AVAILABILITY</th>
        <th translate>PRICE</th>
        <th style="min-width: 200px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId == null">
          <a [routerLink]="['/product/', item.id]" class="text-dark">
            {{ item.id }}
          </a>
        </td>
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a [routerLink]="['/product/', item.id]" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a [routerLink]="['/product/', item.id]" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td [attr.data-label]="'NAME' | translate">
          <a [routerLink]="['/product/', item.id]" class="text-dark">
            {{ item.name }}
          </a>
        </td>
        <td [attr.data-label]="'AVAILABILITY' | translate" *ngIf="includeAvailability">
          <lib-availability [availability]="item.availability" [isSales]="isSales"></lib-availability>
        </td>
        <td [attr.data-label]="'PRICE' | translate">
          <span *ngIf="item.price">
            <span *ngIf="item.price.customerDiscountPercent === 0" translate>NET_PRICE</span>
            <span>
              {{ item.price.customerNetPrice.value | gungCurrency: item.price.customerNetPrice.currencyCode }}
            </span>
          </span>
        </td>
        <td [attr.data-label]="'BUY' | translate" style="width: 200px">
          <div class="input-group" *ngIf="isOnlyDisplay; else buyButton">
            <a [routerLink]="['/product/', item.id]" class="text-dark border-0" style="width: 150px">
              <button class="btn btn-block btn-sm btn-primary" tabindex="-1" translate>DETAILS</button>
            </a>
          </div>
          <ng-template #buyButton>
            <lib-buy-btn
              [id]="item.id"
              [minimumOrderQuantity]="item.packageSize"
              [stepAmount]="item.packageSize"
            ></lib-buy-btn>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="findError" class="mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
